import React, { useState, useEffect } from 'react'
import { Grid, Card, Flexer } from './styled'
import Heart from './Heart'
import Menu from './Menu'
import { SectionTitle } from '../styled'
import { useWeb3React } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useEagerConnect, useInactiveListener } from 'hooks'
import { useDispatch, useSelector } from 'react-redux'
import { fetchBoxycats } from 'state/boxycats/actions/fetchBoxycats'
import { selectBoxyCats } from 'state/boxycats/slice'
import Loader from 'components/Loader'
import Noassets from './NoAssets'
import Noaccount from './NoAccount'
import Fallback from 'components/Fallback'

function Staking(): JSX.Element {
  const context = useWeb3React<Web3Provider>()
  const { connector, account } = context
  // const [boxyCats, setBoxyCats] = useState<string[]>([])
  const dispatch = useDispatch()
  const boxyCats = useSelector(selectBoxyCats)

  // handle logic to recognize the connector currently being activated
  const [activatingConnector, setActivatingConnector] = useState<any>()
  useEffect(() => {
    if (activatingConnector && activatingConnector === connector) {
      setActivatingConnector(undefined)
    }
  }, [activatingConnector, connector])

  // handle logic to eagerly connect to the injected ethereum provider, if it exists and has granted access already
  const triedEager = useEagerConnect()

  // handle logic to connect in reaction to certain events on the injected ethereum provider, if it exists
  useInactiveListener(!triedEager || !!activatingConnector)

  useEffect(() => {
    if (account) dispatch(fetchBoxycats(account))
  }, [account, dispatch])

  const assetsRenderer = () => {
    if (boxyCats.loading === 'loading') {
      return <Fallback height="50vh" />
    }

    if (boxyCats.loading === 'failed') return <Noassets message="Incorrect network" />

    if (!account) return <Noaccount message="You aren't signed in" />

    if (account && boxyCats.tokens.length === 0) {
      return <Noassets message="You don’t have any assets" />
    }

    if (account && boxyCats.tokens.length !== 0) {
      return boxyCats.tokens.map((elm, idx) => (
        <Card key={idx}>
          <Menu />
          <div style={{ marginTop: '24px', textAlign: 'center' }}>
            <img
              src={`https://firebasestorage.googleapis.com/v0/b/axie-boxy.appspot.com/o/NFTs%2f${elm}.png?alt=media`}
              height="auto"
              width="90%"
              alt="gambar yudi"
              style={{
                imageRendering: 'pixelated'
              }}
            />
          </div>
          <Flexer style={{ marginTop: '11px' }}>
            <div style={{ fontSize: '12px', fontWeight: 500 }}>Boxycat</div>
            <Heart style={{ cursor: 'pointer', textAlign: 'center' }} />
          </Flexer>
          <Flexer
            style={{
              color: '#8C8C8C',
              fontSize: '12px',
              fontWeight: 400,
              marginRight: '2px'
            }}
          >
            <div>#{elm}</div>
            <div>20</div>
          </Flexer>
        </Card>
      ))
    }

    return
  }

  return (
    <>
      <SectionTitle as="h2">Inventory</SectionTitle>
      <Grid style={{ paddingTop: '34px' }}>{assetsRenderer()}</Grid>
    </>
  )
}

export default Staking
